module.exports = __webpack_public_path__ + "img/8-preview.fc6d79ac.jpg";